import React from "react";
import { OneKlicksFileSDK } from "../../SDK/OneKlicksFileSDK";
import { oneKlicks } from "../../SDK/oneclick";
import { getuserdata } from "../../services/apiService";

const Gallery = ({ galleryImages = [], setGalleryImages, videos = [], setVideos, newVideoUrl, setNewVideoUrl, isUploading, setIsUploading }) => {

    const parseGalleryImages = (images) => {
        if (typeof images === 'string') {
            try { return JSON.parse(images); } catch (e) { return []; }
        }
        return Array.isArray(images) ? images : [];
    };

    const parseVideos = (videosData) => {
        if (typeof videosData === 'string') {
            try {
                const parsed = JSON.parse(videosData);
                return Array.isArray(parsed) ? parsed.filter(item =>
                    typeof item === 'object' && item !== null && !Array.isArray(item)
                ) : [];
            } catch (e) { return []; }
        }
        return Array.isArray(videosData) ? videosData.filter(item =>
            typeof item === 'object' && item !== null && !Array.isArray(item)
        ) : [];
    };

    const galleryImagesArray = parseGalleryImages(galleryImages);
    const videosArray = parseVideos(videos);

    const handleImageUpload = async (event) => {
        const files = event.target.files;
        setIsUploading(true);
        try {
            const updatedGalleryImages = [...galleryImagesArray];
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const root = "users/gallery";
                const status = "public";
                try {
                    const uploaded = await OneKlicksFileSDK.uploadFile(root, status, file);
                    if (uploaded && uploaded.fileId) {
                        const newImage = {
                            id: Date.now() + i,
                            name: file.name,
                            url: uploaded.fileUrl,
                            fileId: uploaded.fileId,
                            size: (file.size / 1024).toFixed(2) + " KB"
                        };
                        updatedGalleryImages.push(newImage);
                    }
                } catch (uploadError) {
                    console.error("Error uploading file:", uploadError);
                }
            }
            setGalleryImages(updatedGalleryImages);
        } finally {
            setIsUploading(false);
        }
    };

    const handleImageDelete = (imageId) => {
        setGalleryImages(galleryImagesArray.filter(i => i.id !== imageId));
    };

    const getYouTubeEmbedUrl = (url) => {
        try {
            if (url.includes('youtu.be')) {
                const videoId = url.split('youtu.be/')[1].split('?')[0];
                return `https://www.youtube.com/embed/${videoId}`;
            }
            if (url.includes('youtube.com')) {
                const videoId = url.split('v=')[1]?.split('&')[0];
                if (videoId) return `https://www.youtube.com/embed/${videoId}`;
            }
            return url;
        } catch (e) { return url; }
    };

    const handleVideoAdd = async () => {
        if (newVideoUrl) {
            if (typeof newVideoUrl === 'string' && (newVideoUrl.includes('youtube.com') || newVideoUrl.includes('youtu.be'))) {
                const embedUrl = getYouTubeEmbedUrl(newVideoUrl);
                setVideos([...videosArray, { id: Date.now(), name: embedUrl, type: 'youtube' }]);
                setNewVideoUrl("");
            } else if (newVideoUrl instanceof File) {
                setIsUploading(true);
                try {
                    const root = "users/gallery";
                    const uploaded = await OneKlicksFileSDK.uploadFile(root, "public", newVideoUrl);
                    if (uploaded && uploaded.fileId) {
                        setVideos([...videosArray, {
                            id: Date.now(),
                            name: newVideoUrl.name,
                            type: 'local',
                            url: uploaded.fileUrl,
                            fileId: uploaded.fileId,
                            size: (newVideoUrl.size / 1024).toFixed(2) + " KB"
                        }]);
                        setNewVideoUrl("");
                    }
                } finally {
                    setIsUploading(false);
                }
            }
        }
    };

    const handleVideoDelete = (videoId) => {
        setVideos(videosArray.filter(v => v.id !== videoId));
    };

    const handleVideoFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) setNewVideoUrl(file);
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show">
                <div className="dc-profilephoto dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Profile Gallery</h3>
                    </div>
                    <div className="dc-profilephotocontent">
                        <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                            <fieldset>
                                <div className="form-group form-group-label" style={{ position: 'relative' }}>
                                    <div className="dc-labelgroup">
                                        <label htmlFor="gallery-file" className="dc-image-file">
                                            <span className="ajax-load dc-btn">Select Files</span>
                                        </label>
                                        <span>Drop files here to upload</span>
                                        {isUploading && (
                                            <em className="dc-fileuploading">
                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                            </em>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }}
                                        id="gallery-file"
                                    />
                                </div>
                                <div className="form-group uploaded-placeholder">
                                    <ul className="dc-attachfile dc-attachfilevtwo dc-galler-images">
                                        {galleryImagesArray.map((image) => (
                                            <li key={image.id} className="dc-uploadingholder dc-companyimg-user">
                                                <div className="dc-uploadingbox">
                                                    <figure>
                                                        <img className="img-thumb" src={process.env.REACT_APP_API_BASE_URL + image.url} alt={image.name} />
                                                    </figure>
                                                    <div className="dc-uploadingbar">
                                                        <span className="uploadprogressbar"></span>
                                                        <span>{image.name}</span>
                                                        <em>
                                                            File size: {image.size}
                                                            <a href="#" className="dc-remove-gallery-image lnr lnr-cross" onClick={(e) => {
                                                                e.preventDefault();
                                                                handleImageDelete(image.id);
                                                            }}></a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div className="dc-skills dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Videos</h3>
                    </div>
                    <div className="dc-skillscontent-holder">
                        <div className="dc-formtheme dc-skillsform">
                            <fieldset>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter YouTube URL"
                                        value={typeof newVideoUrl === 'string' ? newVideoUrl : ""}
                                        onChange={(e) => setNewVideoUrl(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="file"
                                        accept="video/*"
                                        onChange={handleVideoFileUpload}
                                        className="form-control"
                                    />
                                    {newVideoUrl instanceof File && <p>Selected: {newVideoUrl.name}</p>}
                                </div>
                                <div className="form-group dc-btnarea">
                                    <a href="#" className="dc-btn" onClick={(e) => {
                                        e.preventDefault();
                                        handleVideoAdd();
                                    }}>
                                        Add Video
                                    </a>
                                </div>
                            </fieldset>
                        </div>
                        <div className="dc-myskills">
                            <ul className="list dc-memberships">
                                {videosArray.map((video) => (
                                    <li key={video.id} style={{ display: 'flex', marginBottom: '15px', alignItems: 'center', background: '#f7f7f7', padding: '10px', borderRadius: '4px' }}>
                                        <div style={{ flex: 1 }}>
                                            {video.type === 'youtube' ? (
                                                <iframe width="200" height="112" src={video.name} title="YouTube" frameBorder="0" allowFullScreen></iframe>
                                            ) : (
                                                <video width="200" height="112" src={process.env.REACT_APP_API_BASE_URL + video.url} controls></video>
                                            )}
                                        </div>
                                        <div className="dc-rightarea" style={{ marginLeft: '15px' }}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleVideoDelete(video.id); }}>
                                                <i className="lnr lnr-trash" style={{ color: '#ff5851', fontSize: '18px' }}></i>
                                            </a>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gallery;
